import { createSlice } from '@reduxjs/toolkit';
import { Status } from '@api';

const _settings = {
    splash_ads_active: 0,
    splash_ads: [],
    app_carousel: [],
    otp_expired_time: null,
    can_payment_change_time: {
        num: 0,
        unit: '',
    },
    can_withdraw_request_time: {
        num: 0,
        unit: '',
    },
    social_links: {
        fb_link: '',
        telegram_link: '',
        viber_link: '',
        youtube_link: '',
        app_store_link: '',
        play_store_link: '',
        download_link: '',
        phones: [],
    },
};

const _alert = {
    message: '',
    open: false,
    isError: false,
    successCallback: () => { },
}

const initialState = {
    appStatus: Status.DEFAULT,
    userPreferedLanguage: '',
    settings: _settings,
    alert: _alert,
    is_maintained: false,
    maintain_message: '',
    /**
     * topup bonus modal state
     */
    hasOpened: false,
    is_bonus_accepted: 0,
    has_withdraw_account: false,
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setAppStatus: (state, action) => {
            state.appStatus = action.payload;
        },
        saveSettings: (state, action) => {
            state.settings = action.payload;
        },
        saveUserPreferedLanguage: (state, action) => {
            state.userPreferedLanguage = action.payload;
        },
        clearUserPreferedLanguage: (state, action) => {
            state.userPreferedLanguage = '';
        },
        openAlert: (state, action) => {
            state.alert = { open: true, ...action.payload };
        },
        closeAlert: (state) => {
            state.alert = _alert;
        },
        systemMaintained: (state, action) => {
            state.is_maintained = true;
            state.maintain_message = action.payload;
        },
        setBonusAccepted: (state, action) => {
            state.is_bonus_accepted = action.payload;
        },
        setHasOpened: (state, action) => {
            state.hasOpened = action.payload;
        },
        setHasWithdrawAccount: (state, action) => {
            state.has_withdraw_account = action.payload;
        },
    },
});

export const {
    setAppStatus,
    saveSettings,
    saveUserPreferedLanguage,
    clearUserPreferedLanguage,
    openAlert,
    closeAlert,
    systemMaintained,
    setBonusAccepted,
    setHasOpened,
    setHasWithdrawAccount,
} = appSlice.actions;

export default appSlice.reducer;
